import React from "react";
import { connect } from "react-redux";
import { setTitleAndScrollToTop } from "../actions";
import ReactGA from "react-ga";
import { getRolesOverview } from "../actions/Roles";
import Icon from "../components/Icon";
import Access from "../components/Access";

const mapStateToProps = ( state ) =>
{
	return {
		user: state.user,
		roles: state.roles,
		permissions: state.permissions
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getRolesOverview: () =>
		{
			dispatch( getRolesOverview() );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setTitleAndScrollToTop( title ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class RoleManagement extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			isExpand: {}
		};
		
		this.handleExpand = this.handleExpand.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		const { user, roles } = { ...this.props };
		
		this.props.setTitleAndScrollToTop( "Berechtigungsverwaltung" );
		
		let reload = roles.length === 0;
		reload === false && Object.keys( roles ).every(
			( a_key ) =>
			{
				const role = roles[ a_key ];
				
				if ( !role.hasOwnProperty( "permissions" ) )
				{
					reload = true;
					return false;
				}
				return true;
			}
		);
		
		if ( reload && ( Access.isPermitted( user, [ "get_roles" ] ) || Access.isPermitted( user, [ "get_permissions" ] ) ) )
		{
			this.props.getRolesOverview();
		}
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( "/berechtigungsverwaltung" );
		}
		
	} // function componentDidMount()
	
	/**
	 * Einen Block ein-/ausklappen
	 */
	handleExpand( block_id, expand )
	{
		let is_expand = Object.assign(
			{},
			this.state.isExpand,
			{
				[ block_id ]: expand
			}
		);
		this.setState( { isExpand: is_expand } );
		
	} // function handleExpand(...)
	
	render()
	{
		const { roles, permissions } = { ...this.props };
		
		return <article>
			<section className={"white"}>
				<div className={"col s12"}>
					{
						Object.keys( roles ).length > 0 &&
						<ul className={"collection with-header"}>
							{
								Object.keys( roles ).map(
									( a_key ) =>
									{
										const selectedRole = roles[ a_key ];
										
										return [
											<li className={"collection-header lighter-grey"} key={`role_id_${selectedRole.id}`}>
												<div className="actions actions-right">
													<button className="btn btn-small btn-flat hover-light-grey right"
													        key={`block_expand_id_${selectedRole.id}`}
													        onClick={() => this.handleExpand( selectedRole.id, !this.state.isExpand[ selectedRole.id ] )}>
														<Icon iconName={this.state.isExpand[ selectedRole.id ] ? "shrink" : "expand"}/>
													</button>
												</div>
												{selectedRole.name}<br/><label>{selectedRole.description}</label>
											</li>,
											this.state.isExpand[ selectedRole.id ] !== undefined && this.state.isExpand[ selectedRole.id ] &&
											<li className={"collection-item"} key={`role_permissions_id_${selectedRole.id}`}>
												{
													Object.keys( permissions ).length > 0 &&
													Object.keys( selectedRole.permissions ).length > 0 &&
													Object.keys( permissions ).map(
														( a_key ) =>
														{
															const selectedPermission = permissions[ a_key ];
															const checked = Object.keys( selectedRole.permissions )
																.filter( a_filter_key => selectedRole.permissions[ a_filter_key ] === a_key ).length > 0 ? "checked" : "";
															
															// TODO Berechtigungen als Auswahl darstellen
															return <label key={`permission_id_${selectedPermission.id}`} className={"col s12 m6 xl4"}>
																<input type={"checkbox"}
																       defaultChecked={checked}
																       defaultValue={selectedPermission.name}
																       disabled={true}
																/>
																<span>{selectedPermission.description}</span>
															</label>;
														}
													)
												}
											</li>,
											<li key={`items_clear_${selectedRole.id}`} className="collection-item cleared"/>
										];
									}
								)
							}
						</ul>
					}
				</div>
			</section>
		</article>;
		
	} // function render()
	
} // class

RoleManagement = connect(
	mapStateToProps,
	mapDispatchToProps
)( RoleManagement );

export default RoleManagement;